module.exports = __webpack_public_path__ + "static/media/2014-2015.0bcd3a0d.jpg";